// extracted by mini-css-extract-plugin
export default {"notifications":"Notification_notifications__i91I1","details":"Notification_details__6EP-Q","dot":"Notification_dot__XkEt-"};